window.Zretel or= {}

class window.Zretel.User
